// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Fu5d","noSpacing":"_3Frbs","noSpacingTop":"_1mmPL"};